import { createRouter, createWebHistory } from 'vue-router'
import UninstallView from '../views/UninstallView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: UninstallView,
    },
  ],
})

export default router
